var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1444_2184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9684 18.5069L8.44559 18.0587C7.72486 17.4552 1.43164 12.0202 1.43164 8.04457C1.43164 3.88214 4.80597 0.507812 8.9684 0.507812C13.1308 0.507812 16.5052 3.88214 16.5052 8.04457C16.5052 12.0202 10.2119 17.4553 9.4942 18.0617L8.9684 18.5069ZM8.9684 2.13748C5.70755 2.14117 3.06504 4.78369 3.06134 8.04454C3.06134 10.5421 6.93317 14.5319 8.9684 16.358C11.0037 14.5312 14.8755 10.5391 14.8755 8.04454C14.8718 4.78369 12.2293 2.14121 8.9684 2.13748Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96798 11.0317C7.31802 11.0317 5.98047 9.6941 5.98047 8.04415C5.98047 6.3942 7.31802 5.05664 8.96798 5.05664C10.6179 5.05664 11.9555 6.3942 11.9555 8.04415C11.9555 9.6941 10.618 11.0317 8.96798 11.0317ZM8.96798 6.55036C8.143 6.55036 7.47422 7.21914 7.47422 8.04411C7.47422 8.86909 8.143 9.53787 8.96798 9.53787C9.79295 9.53787 10.4617 8.86909 10.4617 8.04411C10.4617 7.21914 9.79299 6.55036 8.96798 6.55036Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1444_2184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.c3c5388731dc18baa32ffb313c78ea6c.svg";
export { ForwardRef as ReactComponent };